/** Dossier virtuel — fusion INBOX de tous les comptes. */
export const AURELIA_UNIFIED_INBOX_FOLDER = "__aurelia_unified_inbox__";

export const UNIFIED_INBOX_LABEL = "Unifiée";

export function isUnifiedInboxNavFolder(name: string): boolean {
  return name === AURELIA_UNIFIED_INBOX_FOLDER;
}

/** Afficher la réception unifiée dès qu’au moins un compte est connecté. */
export function showUnifiedInboxEntry(accountCount: number): boolean {
  return accountCount >= 1;
}
